import { render, staticRenderFns } from "./select-label.vue?vue&type=template&id=205f23bf&scoped=true"
import script from "./select-label.vue?vue&type=script&lang=js"
export * from "./select-label.vue?vue&type=script&lang=js"
import style0 from "./select-label.vue?vue&type=style&index=0&id=205f23bf&prod&lang=scss&scoped=true"
import style1 from "./select-label.vue?vue&type=style&index=1&id=205f23bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f23bf",
  null
  
)

export default component.exports